import React from 'react'

import { AlertModal, Dropdown, useModalContext } from '@fourthwall/components'

import type { useMemberQuery } from '../../hooks/useMemberQuery'
import { SubscriptionCancelModal } from '../SubscriptionCancelModal'

type Props = {
  member: NonNullable<ReturnType<typeof useMemberQuery>['memberQuery']['data']>
  onSuccess: () => void
}

export const SubscriptionCancel = ({ member, onSuccess }: Props) => {
  const modal = useModalContext()

  const cancelSubscription = () => {
    if (member.cancelRequest.type === 'Allowed') {
      modal.open(SubscriptionCancelModal, {
        member,
        onSuccess,
      })
    } else {
      let text = ''

      if (member.cancelRequest.reason === 'AlreadyRequested') {
        text =
          'Subscription cancellation has already been requested. Please allow up to a minute for changes to show on this page.'
      }

      if (member.cancelRequest.reason === 'IapSubscription') {
        text =
          'Subscriptions managed through the Apple App Store and Google Play Store cannot be canceled here. Please ask your supporter to cancel the subscription on their device.'
      }

      modal.open(AlertModal, {
        title: 'Cancel unavailable',
        text,
        size: 'small',
      })
    }
  }

  if (
    member.cancelRequest.type === 'Disabled' &&
    member.cancelRequest.reason === 'SubscriptionNotActive'
  )
    return null

  return <Dropdown.Item label="Cancel subscription" onClick={cancelSubscription} />
}
